import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

// export lazy route
const FAQ = lazy(() => import("./FAQ"));

const FAQ_ROUTES: RouteObject[] = [
  {
    path: "/public/FAQ",
    element: React.createElement(FAQ),
  },
];

export default FAQ_ROUTES;
